import styled from "styled-components";

export const SubjectsOverviewContainer = styled.div`
	.subjects_overview_sections {
		padding: 80px 0;
		background: white;
	}

	.subjects_list {
		display: flex;
		flex-direction: column;
		gap: 0;
	}

	.subject_item_wrapper {
		display: flex;
		flex-direction: column;
		gap: 0;
		border-top: 2px solid #ccc;
		padding: 30px 0;
	}

	.subject_item {
		display: flex;

		min-height: 300px;

		&:first-child {
			border-top: none;
		}
	}

	.subject_image_section {
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;

		img {
			width: 625px;
			height: 417px;
			object-fit: contain;
		}
	}

	.subject_description_section {
		width: 50%;
		padding: 40px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.subject_title_row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 15px;
		margin-bottom: 12px;
	}

	.subject_logo {
		width: 100px;
		height: 40px;
		object-fit: contain;
	}

	.subject_title {
		font-size: 2rem;
		font-weight: bold;
		color: #021E40;
		margin: 0;
	}

	.subject_description {
		font-size: 17px;
		line-height: 1.6;
		color: #021e40;
		margin: 0;

		.red-text {
			color: #e74c3c;
			font-weight: bold;
		}
	}

	.subject_cards_section {
		display: grid;
		gap: 20px;
		padding: 30px 40px;

		&.two-cards {
			grid-template-columns: repeat(2, 1fr);
		}

		&.three-cards {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	.subject_card {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		padding: 20px;
		background: transparent;
		border-radius: 12px;
		transition: all 0.3s ease;
		align-items:center;
	}

	.card_icon {
		flex-shrink: 0;
		width: 84px;
		height: 103px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: white;
		border-radius: 10px;
		padding: 8px;
		box-shadow: 0px 4px 10px 0px #00000040;
		opacity: 1;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	.card_content {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 20px;
	}

	.card_title {
		font-size: 1.2rem;
		font-weight: bold;
		color: #021e40;
		margin: 0 0 10px 0;
		line-height: 1.3;
	}

	.card_description {
		font-size: 0.95rem;
		line-height: 1.6;
		color: #021e40;
		margin: 0;
	}
	.subjects_overview_sections p {
		line-height: 1.23em;
	}



	@media (max-width: 1199px) {
		.subject_image_section img {
			width: 100%;
			object-fit: contain;
		}
	}
	@media (max-width: 991px) {
		.subjects_overview_sections {
			padding: 60px 0;
		}

		.subject_item {
			flex-direction: column;
			min-height: auto;
		}

		.subject_image_section {
			width: 100%;
			padding: 15px;

			img {
				width: 100%;
				max-width: 500px;
				height: auto;
				max-height: 300px;
			}
		}

		.subject_description_section {
			width: 100%;
			padding: 20px 15px;
		}

		.subject_title_row {
			gap: 10px;
			margin-bottom: 15px;
		}

		.subject_logo {
			width: 80px;
			height: 32px;
		}

		.subject_title {
			font-size: 1.5rem;
			margin: 0;
		}

		.subject_description {
			font-size: 0.9rem;
		}

		.subject_cards_section {
			grid-template-columns: 1fr !important;
			padding: 20px 15px;
			gap: 15px;

			&.two-cards,
			&.three-cards {
				grid-template-columns: 1fr !important;
			}
		}

		.subject_card {
			padding: 0px;
			gap: 10px;
			align-items:center;
		}

		.card_icon {
			width: 70px;
			height: 85px;
			padding: 6px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.card_title {
			font-size: 1.1rem;
			margin: 0 0 8px 0;
		}

		.card_description {
			font-size: 0.9rem;
		}
	}
`;
